/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import "./style.css";

export const ComponentWrapper = ({ className, component = "/img/component-3.png" }) => {
  return <img className={`component-wrapper ${className}`} alt="Component" src={component} />;
};

ComponentWrapper.propTypes = {
  component: PropTypes.string,
};
